import { useLazyQuery } from '@apollo/client';

import {
  PaidService,
  PaidServicesQuery,
  PaidServiceTargetTypeEnum
} from '@/__generated_graphql__/types';
import { GET_PAID_SERVICES } from '@/graphql/queries/payment.queries';
import { CardAd } from '@/types';

import { mapAdToPaidServiceTarget } from '../components/ExtraContent/ExtraContent.helpers';

type Props = {
  updateCallback: (paidServices: PaidService[]) => void;
  onLoading: (isLoading: boolean) => void;
};

export const useFetchPaidServices = ({ updateCallback, onLoading }: Props) => {
  const [fetchPaidService] = useLazyQuery<PaidServicesQuery>(
    GET_PAID_SERVICES,
    {
      fetchPolicy: 'network-only'
    }
  );

  const fetchAndApplyPaidServices = async (
    ad?: CardAd,
    isAddBalance?: boolean
  ) => {
    try {
      onLoading(true);
      const variables = mapAdToPaidServiceTarget(ad);

      const { data: paidServicesData } = await fetchPaidService({
        variables: {
          targetId: isAddBalance ? null : variables.targetId,
          targetType: isAddBalance
            ? PaidServiceTargetTypeEnum.User
            : variables.targetType
        }
      });

      if (paidServicesData) {
        updateCallback(paidServicesData.paidServices);
      }
    } finally {
      onLoading(false);
    }
  };

  return fetchAndApplyPaidServices;
};
